<template>
    <div>
        <dv5-shared-carousel-banner
            :view="banners"
        >
            <div
                class="slide-wrapper"
                :slot="'slide'"
                slot-scope="props"
                :class="props.slideClass"
            >
                <dv5-right-banner-card @openModal="openModalJoinFB" :view="props.slide" v-bind:app="app" />
            </div>
        </dv5-shared-carousel-banner>


        <div class="modal fade modal-v5" id="modalJoinFB" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content modal__facebook">
                    <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h3 v-html="t.translation_join_community"></h3>
                        <div class="groups__list __loading" v-if="processingModal">
                            <ul>
                                <li v-for="z in 3" :key="z">
                                    <div><div class="img"></div></div>
                                    <div><label></label><small></small></div>
                                </li>
                            </ul>
                        </div>
                        <div class="groups__list" v-else>
                            <ul>
                                <li v-for="(fb, index) in facebookLinks" :key="index">
                                    <div>
                                        <div class="img" :style="`background-image: url('/internacional/public/office4/img/dashboard/fb_groups/${fb.pic}.jpg')`"></div>
                                    </div>
                                    <div>
                                        <label v-html="fb.name"></label>
                                        <small v-html="fb.members+'k+ '+t.translation_label_members"></small>
                                    </div>
                                    <div>
                                        <a
                                            :href="fb.linkJoin"
                                            target="_blank"
                                            class="button3 big"
                                            v-html="t.translation_join_fb_group">
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "dv5-right-banner",
    props: ["view", "app", "translation"],
    data() {
        return {
            facebookLinks: [],
            processingModal : false,
            t: this.translation,
        };
    },
    created() {
        this.t = this.translation;
    },

    methods: {
        openModalJoinFB() {
            $('#modalJoinFB').modal('show');
            let vm = this;
            if (Object.keys(vm.facebookLinks).length == 0){
                vm.processingModal = true
                axios
                    .get(vm.t.route_get_groups)
                    .then(function(resposta) {
                        vm.facebookLinks = resposta.data.data
                    })
                    .catch(function(error) {
                        alertMsg(
                            "error",
                            vm.t.get_banner_error
                        )
                    })
                    .finally(function(){
                        vm.processingModal = false
                    });
            }
		}
    },

    computed: {
        banners() {
            if (this.view && this.view != null) {
                // if (this.app == 'banners_ba5') {
                return this.view;
                // } else {
                //     return this.view.banners;
                // }
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// modal facebook
.modal__facebook {
    text-align: center;
    h3 {
        font-weight: normal;
        color: black;
        margin-bottom: 1.4rem;
    }
    .groups__list {
        ul {
            li {
                grid-template-columns: auto 1fr auto;
                display: grid;
                align-items: center;
                gap: 1rem;
                margin: .5rem 0;
                padding: 1rem 0;
                border-top: 1px solid rgba(0, 0, 0, 0.2);

                @media screen and (max-width: 576px) {
                    grid-template-columns: auto 1fr;
                    div:nth-child(3) {
                        grid-column: 1/3;
                        text-align: right;
                        .button3 {
                            width: 100%;
                        }
                    }
                }

                div {
                    text-align: left;
                    &:nth-child(1){
                        .img {
                            width: 70px;
                            border-radius: 50%;
                            height: 70px;
                            background: #F6F6F6;
                            background-size: cover;
                        }
                    }
                    &:nth-child(2){
                        grid-auto-flow: row;
                        display: grid;
                        label {
                            color: black;
                        }
                        small {
                            color: #5B5B5B;
                            font-size: 0.8rem;
                            margin-top: 5px;
                        }
                    }
                }

            }
        }
        &.__loading {
            .img, label, small, button {
                animation-duration: 1.5s;
                animation-fill-mode: forwards;
                animation-iteration-count: infinite;
                animation-name: placeHolderShimmerFb;
                animation-timing-function: linear;
                background: linear-gradient(to right, #F6F6F6 10%, #F0F0F0 38%, #F6F6F6 63%);
                position: relative;
            }
            small, label {
                height: 13px;
            }
        }
    }
    a {
        font-weight: bold;
    }
}

@keyframes placeHolderShimmerFb{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/banners/RightBanner.vue